import { Routes, Route, Navigate } from "react-router-dom";

import SettingsLayout from "./layout";
import Company from "./company";
import Culture from "./culture/index";
import Career from "./career";
import Billing from "./billing";
import Templates from "./templates";
import WhatsApp from "./whatsapp";
import Email from "./email";
import Screening from "./screening";
import IframeEmbed from "./iframe";

export default function Organisation() {
  return (
    <Routes>
      <Route element={<SettingsLayout />}>
        <Route path="company" element={<Company />} />
        <Route path="culture" element={<Culture />} />
        <Route path="career" element={<Career />} />
        <Route path="billing" element={<Billing />} />
        <Route path="templates" element={<Templates />} />
        <Route path="whatsapp" element={<WhatsApp />} />
        <Route path="email" element={<Email />} />
        <Route path="screening" element={<Screening />} />
        <Route path="iframe" element={<IframeEmbed />} />
        <Route path="" element={<Navigate to="company" replace />} />
      </Route>
    </Routes>
  );
}
